const SearchTypes = {
  SET_SEARCH_RESULT: "themet/setSearchResult", // list  search objects based on some criterias
  CLEAN_SEARCH: "themet/searchObject",
};

export default SearchTypes;
